module.exports = __webpack_public_path__ + "static/media/logo-comjoo-color-black-vert.c0130efb.svg";